var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAssignmentTurnedInGradient46Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0033AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0033AD"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6-2h46v46H-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M36.667 5.833h-8.012C27.85 3.61 25.742 2 23.25 2c-2.492 0-4.6 1.61-5.405 3.833H9.833A3.845 3.845 0 0 0 6 9.667V36.5a3.845 3.845 0 0 0 3.833 3.833h26.834A3.845 3.845 0 0 0 40.5 36.5V9.667a3.845 3.845 0 0 0-3.833-3.834zm-13.417 0c1.054 0 1.917.863 1.917 1.917a1.922 1.922 0 0 1-1.917 1.917 1.922 1.922 0 0 1-1.917-1.917c0-1.054.863-1.917 1.917-1.917zm-3.833 26.834L11.75 25l2.703-2.703 4.964 4.945 12.63-12.63 2.703 2.721-15.333 15.334z",
    transform: "translate(-6 -2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAssignmentTurnedInGradient46Px);
export default __webpack_public_path__ + "static/media/ic-assignment-turned-in-gradient-46-px.8ca57cd3615a657fb95bcbf48939e292.svg";
export { ForwardRef as ReactComponent };